var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auxiliar-lance"},[_c('div',{staticClass:"title"},[_vm._v("AUXILIAR DE LANCE")]),_c('div',{staticClass:"buttons"},_vm._l((_vm.valores),function(valor){return _c('u-btn',{key:valor,attrs:{"label":'R$ ' + _vm.$options.filters.moeda(valor)},on:{"click":function($event){return _vm.$emit('lance', valor)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }